import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
// import { ImagesLoader } from '../../smart/utils/images-loader/ImagesLoader';
import { ServiceSelector } from '../../smart/utils/images-loader/ServiceSelector';
import { ServiceSelector_docs } from '../../smart/utils/docs-loader/ServiceSelector';
import { Loader } from '../utils/loader/Loader';
import './servicedetailarea.scss';
import { Markup } from 'interweave';
// import { Services } from '../Services';

type props = {}

export const ServiceDetailArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);
    // console.log(props.filename)
    const myLoader = ServiceSelector.select(props.filename),
    myLoader_docs = ServiceSelector_docs.select(props.filename);
    // console.log(myLoader)
    useLayoutEffect(() => setIsOnline(true), [setIsOnline]);

    // useEffect(() => console.log("sono il dettaglio di single service ", props.contents["title"] ));

    if (isOnline === false) {
        return <Loader />;
    }
    else
        return <div className="portfolio_details_area">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8 offset-xl-2">
                        <div className="portfolio_details_content text-center mb-50">
                            {/* <span>{props.contents.title}</span> */}
                            <h3>{props.contents.subtitle}</h3>
                            <p style={{ whiteSpace: "pre-line" }}>
                                <Markup content={props.contents.p1 !== undefined ? props.contents.p1 : ""} />
                            </p>
                        </div>
                    </div>
                    <div className="col-xl-12 d-flex justify-content-center">
                        <div className={"portfolio_details_thumb " + props.filename.replace(/ /g, '')}>
                            <img src={myLoader?.SDA_first} alt="" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-8 offset-xl-2">
                        <div className="portfolio_details_content mt-50 mb-50 text-center">
                            {/* <h4>The Result</h4> */}
                            <p style={{ whiteSpace: "pre-line" }}>
                                <Markup content={props.contents.p2 !== undefined ? props.contents.p2 : ""} />
                            </p>
                            {/* <div className="live_view_btn mt-50">
                                <a href="/#" className="boxed-btn3-green-2">Live View</a>
                            </div> */}
                        </div>
                        <div className="portfolio_details_content mt-50 mb-50 text-center">
                            <h4><Markup content={props.contents.p30_title !== undefined ? props.contents.p30_title : ""} /></h4>
                            <p style={{ whiteSpace: "pre-line" }}>
                                <Markup content={props.contents.p30 !== undefined ? props.contents.p30 : ""} />
                            </p>
                            {/* <div className="live_view_btn mt-50">
                                <a href="/#" className="boxed-btn3-green-2">Live View</a>
                            </div> */}
                        </div>
                        <div className="portfolio_details_content mt-50 mb-50 text-center">
                            <h4><Markup content={props.contents.p31_title !== undefined ? props.contents.p31_title : ""} /></h4>
                            <p style={{ whiteSpace: "pre-line" }}>
                                <Markup content={props.contents.p31 !== undefined ? props.contents.p31 : ""}/>
                            </p>
                            
                            {/* <div className="live_view_btn mt-50">
                                <a href="/#" className="boxed-btn3-green-2">Live View</a>
                            </div> */}
                        </div>
                        <div className="portfolio_details_content mt-50 mb-50 text-center">
                            <h4><Markup content={props.contents.p32_title !== undefined ? props.contents.p32_title : ""} /></h4>
                            <p style={{ whiteSpace: "pre-line" }}>
                                <Markup content={props.contents.p32 !== undefined ? props.contents.p32 : ""} />
                            </p>
                            {/* <div className="live_view_btn mt-50">
                                <a href="/#" className="boxed-btn3-green-2">Live View</a>
                            </div> */}
                        </div>
                        <div className="portfolio_details_content mt-50 mb-50 text-center">
                            <h4><Markup content={props.contents.p33_title !== undefined ? props.contents.p33_title : ""} /></h4>
                            <p style={{ whiteSpace: "pre-line" }}>
                                <Markup content={props.contents.p33 !== undefined ? props.contents.p33 : ""} />
                            </p>
                            {/* <div className="live_view_btn mt-50">
                                <a href="/#" className="boxed-btn3-green-2">Live View</a>
                            </div> */}
                        </div>
                        <div className="portfolio_details_content mt-50 mb-50 text-center" style={{ display: myLoader_docs?._visible ? 'block' : 'none' }}>
                            <div className="download_btn">
                                {/* <a className="boxed-btn3" href="/#">About Us</a> */}
                                <Link className="boxed-btn3" onClick={() => {

                                    // props.clickhandler("about")
                                    console.log(myLoader_docs?._title)
                                }
                                } to={'//' + myLoader_docs?._link} target='_blank'> {myLoader_docs?._title} </Link>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-xl-12">
                        <div className="portfolio_details_thumb">
                            <img src={myLoader?.SDA_second} alt="" />
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
}